export default __webpack_public_path__ + "static/media/P10019.4737ab92.png";